import { Component, inject } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { getAuthItem } from '../../store/auth/auth-session';

@Component({
  selector: 'app-not-found',
  imports: [TranslateModule, MatIconModule],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
})
export class NotFoundComponent {
  private router = inject(Router);
  private location = inject(Location);

  private get isLoggedIn(): boolean {
    try {
      return !!getAuthItem('token');
    } catch {
      return false;
    }
  }

  goHome(): void {
    this.router.navigateByUrl(this.isLoggedIn ? '/main/records' : '/auth/login');
  }

  goBack(): void {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      this.goHome();
    }
  }
}
